<div class="container" *ngIf=!mostrar >
    
</div>